<template>
    <kiosk-team-details :teamId="props.teamId">
        <div
            class="vx-col-span-12 lg:vx-col-span-10 vx-flex vx-flex-col vx-w-full vx-max-w-screen-sm vx-justify-center"
        >
            <plan-information
                v-model="team"
                :teamPlan="props.teamPlan"
                :teamMessageBalance="props.teamMessageBalance"
                :teamSumBalanceAmount="props.teamSumBalanceAmount"
                :kioskMode="true"
            >
            </plan-information>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '~/components/kiosk/kiosk-teams/KioskTeamDetails.vue';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/useTeamDetails';
import PlanInformation from '~/components/settings/teams/plan-information/PlanInformation.vue';

const { team } = useTeamDetails();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    teamPlan: {
        type: Object,
        required: true,
    },
    teamMessageBalance: {
        type: Number,
        required: true,
    },
    teamSumBalanceAmount: {
        type: Number,
        required: true,
    },
});
</script>
